import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = ["title"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["href", "target", "title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_ctx.mode === 'app')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _ctx.link,
            target: _ctx.target,
            disabled: true,
            title: _ctx.title
        }, {
            default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
        }, 8, ["to", "target", "title"]))
        : (_ctx.mode === 'app-modal')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.runModal && _ctx.runModal(...args)), ["prevent"])),
                title: _ctx.title
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 8, _hoisted_1))
            : (_ctx.mode === 'action')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.runAction && _ctx.runAction(...args)), ["prevent"])),
                    title: _ctx.title
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 8, _hoisted_2))
                : (_ctx.mode === 'client-action')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.runActionClient && _ctx.runActionClient(...args)), ["prevent"])),
                        title: _ctx.title
                    }, [
                        _renderSlot(_ctx.$slots, "default")
                    ], 8, _hoisted_3))
                    : (_ctx.mode === 'link')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 4,
                            href: _ctx.link,
                            target: _ctx.target,
                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('link-click', $event))),
                            title: _ctx.title
                        }, [
                            _renderSlot(_ctx.$slots, "default")
                        ], 8, _hoisted_4))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 5,
                            onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.$emit('link-click', $event))),
                            class: _normalizeClass(_ctx.defaultClass),
                            style: { "cursor": "pointer" }
                        }, [
                            _renderSlot(_ctx.$slots, "default")
                        ], 2));
}
